module.exports = __webpack_public_path__ + "static/media/p9.68304cbe.jpg";